import React, { useEffect } from "react";
import TreeIcon from "../public/tree-icon.svg";
import { useAppDispatch, useAppSelector } from "../utils/redux/hooks";
import { adduserData } from "../utils/redux/mainSlice";
import { RootState } from "../utils/redux/store";
import { getUser } from "../utils/apis/func";

const ProfilePage = () => {
  const dispatch = useAppDispatch();
  const userData: any = useAppSelector(
    (store: RootState) => store.user.userData
  );

  useEffect(() => {
    const fetchData = async () => {
      // console.log('started', d);
      const res: any = await getUser("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(adduserData(res?.data?.user));
      }
    };
    fetchData();
  }, [dispatch]);
  return (
    <div className="lg:w-1/2 w-full ">
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4 pr-16">
          Profile
        </p>
      </div>
      <main className="flex flex-col gap-7 w-full lg:w-3/5 font-roboto text-sm font-normal leading-normal px-4 lg:px-6 mt-8">
        <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center">
            Name:{" "}
            <input
              value={`${userData?.firstName} `}
              className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
            ></input>
          </p>
        </div>
        <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center">
            Email:{" "}
            <input
              value={`${userData?.email}`}
              className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
            ></input>
          </p>
        </div>
        <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center">
            Phone No:{" "}
            <input
              value={`${userData?.phoneNumber}`}
              className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
            ></input>
          </p>
        </div>
        <div className=" bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center whitespace-nowrap overflow-hidden ">
            Date Of Birth:{" "}
            <input
              value={`${userData?.dob}`}
              className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
            ></input>
          </p>
        </div>
        <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center">
            Address:{" "}
            <input
              value={`${userData?.address}`}
              className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
            ></input>
          </p>
        </div>
        {/* <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
          <p className="flex items-center">
            Profile Image:{" "}
            <span className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between">
              Choose File
            </span>
          </p>
        </div> */}
        {/* <div className="flex justify-center items-center">
          <img src={TreeIcon} alt="Tree" />
        </div> */}
      </main>
    </div>
  );
};

export default ProfilePage;
